import React from 'react';
import { Auth } from 'aws-amplify';
import { withApollo } from 'react-apollo';
import { compose, mapProps } from 'recompose';
import { withRouter } from 'react-router-dom';

import Routes from 'utils/routes/appRoutes';
import { clearOktaSession } from '../../graphql/operations';
import { NO_CACHE } from '../../graphql/fetchPolicies';
import LoadingPage from '../../components/common/Loader/Spinner/Spinner';

export class Logout extends React.Component {
  userLogout = async () => {
    // sign out from okta
    const { apolloClient } = this.props;
    await apolloClient
      .mutate({
        mutation: clearOktaSession,
        variables: { user: Auth.user.username },
        fetchPolicy: NO_CACHE
      })
      .catch(err => console.log(err));

    // sign out from cognito
    await Auth.signOut({ global: true }).catch(err => console.log(err));
  };

  componentDidMount() {
    if (Auth.user !== null) {
      this.userLogout().then();
    } else {
      sessionStorage.removeItem('redirectPath');
      window.location.href = Routes.home.path;
    }
  }

  render() {
    return <LoadingPage size="lg" expanded isFullWidth />;
  }
}

export const LogoutHOC = compose(
  withApollo,
  withRouter,
  mapProps(props => {
    return {
      t: props.t,
      apolloClient: props.client,
      history: props.history
    };
  })
);

export default LogoutHOC(Logout);
